import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/lib/auth";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Landing from "@/pages/Landing";
import PropertySignup from "@/pages/PropertySignup";
import MspSignup from "@/pages/MspSignup";
import Partners from "@/pages/Partners";
import PaymentResult from "@/pages/PaymentResult";

const Loading = () => (
  <div className="min-h-screen grid place-items-center font-mono text-xs text-slate-500" data-testid="app-loading">
    Opening the door…
  </div>
);

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null) return <Loading />;
  return user ? children : <Navigate to="/login" replace />;
}

function PublicOnly({ children }) {
  const { user } = useAuth();
  if (user === null) return <Loading />;
  return user ? <Navigate to="/app" replace /> : children;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<PublicOnly><Login /></PublicOnly>} />
          <Route path="/app" element={<Protected><Dashboard /></Protected>} />
          <Route path="/signup" element={<PublicOnly><PropertySignup /></PublicOnly>} />
          <Route path="/p/:slug" element={<PublicOnly><PropertySignup /></PublicOnly>} />
          <Route path="/partners" element={<Partners />} />
          <Route path="/msp/signup" element={<PublicOnly><MspSignup /></PublicOnly>} />
          <Route path="/payment/success" element={<PaymentResult />} />
          <Route path="/payment/cancel" element={<PaymentResult canceled />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster theme="dark" position="bottom-right" />
    </AuthProvider>
  );
}

export default App;
